import { styled } from '@mui/material/styles';
import { DS_typography as coreTypography } from 'mui/base/theme/DS_Tokens/core';

export const StyledAccordionWrapper = styled('div')(
  ({ theme }) => `
 
    .MuiAccordion-root {
      border-radius: 0.75rem;
      border: 1px solid ${theme.DS_palette.border.light};
      padding: ${theme.DS_spacing(['md'])};
      margin-top: ${theme.DS_spacing(['md'])} !important;
      box-shadow: none !important;
    }
    
    .MuiAccordionSummary-content {
      color: ${theme.DS_palette.cards.attention};
    }
    .MuiAccordionDetails-root {
      color: ${theme.DS_palette.text.secondary};
      font-weight: ${coreTypography.fontWeight.medium};
      line-height: ${coreTypography.lineHeight.lvl5};

      ${theme.breakpoints.up('lg')} {
        font-size: ${coreTypography.fontSize.lvl4};
        line-height: ${coreTypography.lineHeight.lvl8};
      }
    }
    
    ${theme.breakpoints.up('lg')} {
      .MuiAccordion-root {
        margin-top: ${theme.DS_spacing(['lgx'])} !important;
      }
    }
  `,
);
